import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ItemUnidade } from '../item-unidade';

@Injectable({
    providedIn: 'root'
})
export class ItemUnidadeCrudHttpService implements Crud<ItemUnidade> {
    resource = 'itemunidade';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas as unidades cadastradas */
    search(): Observable<ItemUnidade[]> {
        return this.crudService.search<ItemUnidade>(this.resource);
    }

    /** Procura uma única unidade através do seu ID */
    find(id: number): Observable<ItemUnidade> {
        return this.crudService.find<ItemUnidade>(this.resource, id);
    }

    /** Carrega uma única unidade através do seu ID */
    load(id: number): Observable<ItemUnidade> {
        return this.crudService.load<ItemUnidade>(this.resource, id);
    }

    /** Insere uma nova unidade */
    insert(entity: ItemUnidade): Observable<ItemUnidade> {
        return this.crudService.insert<ItemUnidade>(this.resource, entity);
    }

    /** Altera uma unidade existente */
    update(entity: ItemUnidade): Observable<ItemUnidade> {
        return this.crudService.update<ItemUnidade>(this.resource, entity);
    }

    /** Exclui uma unidade através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
